export default __webpack_public_path__ + "static/media/profile.d94adcb9.jpg";